import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polygon,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polygon, { points: "12 2 2 7 12 12 22 7 12 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "2 17 12 22 22 17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "2 12 12 17 22 12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Layers";
const Layers = memo(themed(Icon));
export {
  Layers
};
//# sourceMappingURL=layers.js.map
